import _                                 from 'underscore';
import React, { FC, ReactNode }          from 'react';
import { Sidebar, SidebarProps }         from 'semantic-ui-react';
import { Flexbox, FlexItem }             from '.';
import { TogglableContentHook }          from '../../hooks/useTogglableContentReducer';
import { FlexAlign, FlexFlow, Position } from '../../types/componentPropTypes';

export interface SplitScreenWithSidebarProps {
	sidebar: TogglableContentHook,
	leftComponent: ReactNode,
	rightComponent: ReactNode,

	onHide?(): void,

	onHidden?(): void,
}

const defaultProps: SplitScreenWithSidebarProps = {
	sidebar:        null,
	onHide:         () => {},
	onHidden:       () => {},
	leftComponent:  React.Fragment,
	rightComponent: React.Fragment,
}

// WARNING: Magic number.
const heightOffset = 127;

const SplitScreenWithSidebar: FC<SplitScreenWithSidebarProps> = React.memo( ( props ) => {

	let {
		    sidebar:        customSidebar,
		    leftComponent:  ComponentLeft,
		    rightComponent: ComponentRight,
	    } = props;

	if( !customSidebar ){
		throw new Error( 'A sidebar created by the useSidebar hook must be given to the SplitScreenWithSidebar component.' )
	}

	let [ sidebar, sidebarActions ] = customSidebar;

	const handleOnHide = ( e: React.MouseEvent<HTMLElement>, data?: SidebarProps ): void => {
		_.isFunction( props.onHide )
		? props.onHide()
		: sidebarActions.toggle( false )
	}

	const handleOnHidden = (): void => {
		if( _.isFunction( props.onHidden ) ){
			props.onHidden()
		}
	}

	return (

		<Sidebar.Pushable>

			<Sidebar visible={ sidebar.isOpen }
			         animation={ 'overlay' }
			         direction={ 'right' }
			         width={ 'very wide' }
			         onHide={ handleOnHide }
			         onHidden={ handleOnHidden }
			         style={ { width: 'calc(50%)', height: `calc( 100% - ${ heightOffset }px )` } }>

				<div className={ 'padding-md container--colored-bg-white container--fill-area overflow-content--y' } style={ { height: `calc( 100% - ${ heightOffset }px )` } }>

					{ sidebar.content }

				</div>

			</Sidebar>
			<Sidebar.Pusher dimmed={ false }>


				<Flexbox align={ FlexAlign.START }
				         direction={ FlexFlow.COLS }
				         cols={ 2 }
				         className={ 'container--fill-area' }
				         style={ { bottom: heightOffset } }>

					<FlexItem position={ Position.ABSOLUTE }
					          className={ 'split-screen-left position--top position--bottom position--left overflow-content--y' }
					          contentClasses={ 'padding-lg-bottom' }>

						{ ComponentLeft }

					</FlexItem>
					<FlexItem position={ Position.ABSOLUTE }
					          className={ 'split-screen-right position--top position--bottom position--right overflow-content--y border-sm-left border--colored-lt-gray' }
					          contentClasses={ 'padding-lg-bottom' }>

						{ ComponentRight }

					</FlexItem>
				</Flexbox>

			</Sidebar.Pusher>

		</Sidebar.Pushable>

	);
} );

// @ts-ignore
// SplitScreenWithSidebar.whyDidYouRender = false;

SplitScreenWithSidebar.defaultProps = defaultProps;

export { SplitScreenWithSidebar }
